export const JOB_TYPE_OPTIONS = ['AirbnbClean', 'Task'];
